import Link from 'next/link'
import { FC } from 'react'

import { useMediaQueries } from '@/shared/lib/hooks/useMediaQueries'

import styles from './SubscribeLine.module.scss'

export interface SubscribeItem {
	iconId: string
	title: string
	description: string
	link: string
	linkTitle: string
	background: string
	color: string
	backgroundMob: string
}

interface Props {
	items: SubscribeItem[]
}

const SubscribeLine: FC<Props> = ({ items }) => {
	const { isMobile } = useMediaQueries()
	return (
		<ul className={styles.SubscribeLine}>
			{items.map((item: SubscribeItem, index: number) => (
				<li key={index}>
					<Link prefetch={false} href={item.link} target="_blank">
						<article
							key={index}
							className={styles.SubscribeLine__Item}
							style={{ backgroundImage: `url(${isMobile ? item.backgroundMob : item.background}` }}>
							<div className={styles.text}>
								<h2 className={styles.SubscribeLine__ItemTitle}>{item.title}</h2>
								<p className={styles.SubscribeLine__ItemSubtitle}>{item.description}</p>
							</div>
							<span title={item.linkTitle} className={styles.SubscribeLine__ItemLink} style={{ color: item.color }}>
								Подписаться
							</span>
						</article>
					</Link>
				</li>
			))}
		</ul>
	)
}

export default SubscribeLine
